import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import PropTypes from 'prop-types';
import FilterSeries from './FilterSeries';
import InteractiveScale from './InteractiveScale';

var TabSeries = function TabSeries(_ref) {
  var props = _extends({}, _ref);
  /**
   * Returns tab description transl and markup if one is provided
   * @param  Object metric Object with metric data
   * @return String HTML string
   */


  var getTabDesc = function getTabDesc(metric) {
    if (metric.desc && metric.desc.length > 0) {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx('tab-desc', 'tab-desc-' + metric.tabId),
        dangerouslySetInnerHTML: {
          __html: i18n.translate(metric.desc)
        }
      });
    } else {
      return '';
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: clsx('filter-panel-tabs', props.activeTab ? 'active-tab-' + props.activeTab : '')
  }, props.tabs.map(function (t) {
    var metric = props.metrics.find(function (m) {
      return m.id === t;
    });
    var tabLabel = i18n.translate(metric.title);
    var tabId = metric.tab;
    return /*#__PURE__*/React.createElement("div", {
      className: clsx('filter-tab-category', metric.tab ? 'tab-category-' + metric.tab : ''),
      key: metric.tab
    }, /*#__PURE__*/React.createElement("h5", null, tabLabel), getTabDesc(metric), /*#__PURE__*/React.createElement("div", {
      className: clsx('filter-select', 'tab-' + tabId),
      key: t
    }, /*#__PURE__*/React.createElement(InteractiveScale, {
      metric: metric
    })), /*#__PURE__*/React.createElement(FilterSeries, {
      tab: tabId,
      metrics: props.metrics
    }));
  }));
};

FilterSeries.propTypes = {
  tabs: PropTypes.array,
  metrics: PropTypes.array,
  activeTab: PropTypes.string
};
FilterSeries.defaultProps = {
  tabs: [],
  metrics: [],
  activeTab: 'cri'
};
export default TabSeries;